import { render, staticRenderFns } from "./Footer15.vue?vue&type=template&id=e0fde15e&"
import script from "./Footer15.vue?vue&type=script&lang=js&"
export * from "./Footer15.vue?vue&type=script&lang=js&"
import style0 from "./Footer15.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Footer15.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports